export * from './hook/useLazyQuery$';
export * from './hook/useMutation$';

export * from './component/LastRunAt';
export * from './component/ReRunQueryButton';

export const toRelayId = (guid: string, typeName: string) => btoa(`${typeName}:${guid}`);
export function getDomainGraphqlError (e: any): string {
    if (e?.graphQLErrors && e?.graphQLErrors.length > 0) {
        return e?.graphQLErrors[0]?.extensions?.message;
    }

    return '';
}
